/**
 * Single source of truth for the Cold Email Agent's route base.
 *
 * The feature physically lives under `src/crm/` (the walled CRM sub-app) but is
 * surfaced in the Marketing section at `/marketing/cold-email`. Internal
 * navigation MUST go through this helper so there is one place to repoint if the
 * mount ever moves (mirrors email-campaign-routes.ts).
 */
export const COLD_EMAIL_BASE = "/marketing/cold-email";

export function coldEmailPath(sub = ""): string {
  return `${COLD_EMAIL_BASE}${sub}`;
}
